<div class="voltar" (click)="voltar()">
  <img src="assets/images/back.svg" />
  <span>Voltar</span>
</div>
